import api from "./index";

/**
 * Update user language
 * @param {string|number} userid - User ID
 * @param {string} language - Language code (e.g., 'en', 'cs', 'fr')
 * @returns {Promise<{ success: boolean }>}
 */
export async function updateLanguage(userid, language) {
  const res = await api.post(
    "/user/updateLanguage",
    { userid: String(userid), language },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
}
